<div class="modal is-touch is-short is-open">
  <div class="modal__content">
    <div class="modal__header flex align-center h2">
      <svg>
        <use xlink:href="./assets/icons/connect-icons.svg#Bad-Gateway"></use>
      </svg>
      <div class="ml2">Access Denied</div>
    </div>
    <div class="modal__body">
      <div class="h3 pb2">You do not have access to this station.</div>
      The administrator of this station has not granted you access to this station.
    </div>
    <div class="modal__footer flex justify-content-end">
      <button class="btn btn--true-blue right js-modal-toggle" id="btnOk" (click)="onOkButtonClicked()">Ok</button>
    </div>
  </div>
</div>
